import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  link: {
    margin: theme.spacing(0, 1, 0, 1),
    whiteSpace: 'nowrap',
    color: props =>
      props.isActive
        ? theme.editorPalette.primary.main
        : theme.editorPalette.text.primary,
  },
  container: {
    height: 50,
    position: 'absolute',
    width: '100%',
    borderBottom: props =>
      !props.isSticky
        ? `1px solid ${theme.editorPalette.primary.main}`
        : `1px solid ${theme.editorPalette.common.white}`,
    borderTop: props =>
      !props.isSticky
        ? `1px solid ${theme.editorPalette.primary.main}`
        : `1px solid ${theme.editorPalette.common.white}`,
    display: 'flex',
    alignItems: 'center',
    //justifyContent: 'center',
    backgroundColor: theme.editorPalette.common.white,
    overflowX: 'auto',
    overflowY: 'hidden',
    '&:before': {
      content: '""',
      margin: 'auto',
    },
    '&:after': {
      content: '""',
      margin: 'auto',
    },
  },
}));

// this is the container for the ToC
const Container = ({ isSticky, ...props }) => {
  const classes = useStyles({ isSticky });
  return (
    <Box
      className={classes.container}
      boxShadow={isSticky ? 1 : 0}
      {...props}
    />
  );
};

// this will be rendered for each item on the ToC
const Item = ({ isActive, ...props }) => {
  const classes = useStyles({ isActive });
  return (
    <Typography
      className={classes.link}
      variant="body2"
      component="a"
      color="inherit"
      {...props}
    />
  );
};

Item.propTypes = {
  isActive: PropTypes.bool.isRequired,
};

Item.defaultProps = {};

const config = {
  blockTypes: ['header-one'],
  item: Item,
  container: Container,
};

export default config;
